import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    footer: en,
  },
  fr: {
    footer: fr,
  },
  pt: {
    footer: pt,
  },
};
